/* Der eine Supabase-Zugang der App.
 *
 * WICHTIG — Reihenfolge: Einladungs- und Passwort-zurücksetzen-Links tragen
 * ihre Information im Adressanker (#access_token=…). Supabase entfernt ihn
 * beim Start. Deshalb wird er hier gesichert, BEVOR createClient() läuft.
 * Dieses Modul muss daher als erstes importiert werden — siehe main.js.
 *
 * Außerhalb dieses Ordners darf es keine direkten Supabase-Aufrufe geben.
 * Alles läuft über die Module hier daneben.
 */

import { createClient } from '@supabase/supabase-js';

/** Adressanker vor dem Start sichern — muss die erste Anweisung bleiben. */
export const INITIAL_HASH = typeof window !== 'undefined' ? window.location.hash || '' : '';

const cfg = (typeof window !== 'undefined' && window.GRASSRUNNERS_CONFIG) || {};

/* Lokaler Stack: NUR im Vite-Modus "localstack" (npm run dev:local) zieht die URL aus
   .env.local statt aus public/config.js. Die Modus-Prüfung ist Absicht: Vite lädt
   .env.local in JEDEM Modus, auch beim Build — ohne sie könnte eine Produktivfassung
   mit der lokalen Adresse entstehen. So wird der Zweig im Build entfernt. */
const local = import.meta.env.MODE === 'localstack' ? import.meta.env : {};

export const SUPABASE_URL = (local.VITE_SUPABASE_URL || cfg.SUPABASE_URL || '').trim();
export const SUPABASE_ANON_KEY = (local.VITE_SUPABASE_ANON_KEY || cfg.SUPABASE_ANON_KEY || '').trim();
export const VAPID_PUBLIC_KEY = (cfg.VAPID_PUBLIC_KEY || '').trim();

/**
 * Null, wenn keine Konfiguration hinterlegt ist. Die App muss diesen Fall
 * vertragen und eine klare Meldung zeigen — nicht mit Beispieldaten starten.
 */
export const supabase =
  SUPABASE_URL.startsWith('http') && SUPABASE_ANON_KEY
    ? createClient(SUPABASE_URL, SUPABASE_ANON_KEY)
    : null;

export const isConfigured = supabase !== null;

/** Storage-Bucket für alle Spielerdokumente. Privat — Zugriff nur über signierte Links. */
export const STORAGE_BUCKET = 'player-files';
